<template>
  <div class="user-basic-info">
    <UserBasicInfo :username="getUser?.name" :details="details" />
    <UserAccoutingDeatils
      v-if="getUser?.Customer?.balance || getUser?.Customer?.maxBalance"
      :balance="getUser?.Customer?.balance"
      :maxBalance="getUser?.Customer?.maxBalance"
    />
    <div class="d-flex align-center ga-2">
      <v-icon icon="mdi-logout" size="20" />
      <span @click="logOut" class="logout text-decoration-underline">{{
        $t("AccountPage.UserInfo.logoutLink")
      }}</span>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import UserBasicInfo from "./UserBasicInfo.vue";
import UserAccoutingDeatils from "./UserAccoutingDeatils.vue";

export default {
  components: { UserBasicInfo, UserAccoutingDeatils },
  methods: {
    async logOut() {
      await this.$store.dispatch("AuthModule/logout");
      // reload
      this.$router.replace("/");
      window.location.reload();
    },
  },
  computed: {
    details() {
      return [
        {
          icon: "mdi-map-marker",
          key: "כתובת למשלוח",
          value: this.getUserCustomerAddress,
        },
        {
          icon: "mdi-mailbox",
          key: 'דו"אל',
          value: this.getUser?.Customer?.email ?? null,
        },
      ];
    },
    ...mapGetters({
      getUser: "AuthModule/getUser",
      getUserCustomerAddress: "AuthModule/userCustomerAddress",
    }),
  },
};
</script>

<style scoped lang="scss">
.logout {
  color: $DeepGray;
  font-size: $mediumTextSize;
  font-weight: 400;
  cursor: pointer;
}
.user-basic-info {
  height: fit-content;
  display: flex;
  padding: 20px;
  flex-direction: column;
  align-items: flex-start;
  gap: 20px;
  border-radius: 10px;
  border: 1px solid var(--Lite-Grey, #dcdcdc);
}
</style>
